<script setup lang="ts">
import { ref, computed } from 'vue';
import Contact from '@/pages/Contact.vue';
import NotFound from '@/pages/NotFound.vue';

interface routeArray {
  [index: string]: any;
}

const routes: routeArray = {
  '/contact': Contact
}

const currentPath = ref(window.location.pathname);
console.log(`currentPath=${currentPath.value}`);

const currentView = computed(() => {
  let index: string = currentPath.value || '/';
  return routes[index] || NotFound
})

</script>
<template>
  <component :is="currentView" />
</template>